import React from 'react';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { InsiderSection } from './insider-section';

export function DesktopInsiderSection() {
  return (
    <FeatureFlag name="insider">
      <div className="d-flex align-items-center flex-no-shrink">
        <InsiderSection className="d-flex flex-row flex-nowrap justify-content-end ms-auto" isGlobalNavDesktop />
      </div>
    </FeatureFlag>
  );
}
